import * as types from "../types";

export function setUsers(users) {
  return {
    type: types.SET_USERS,
    users,
  };
}
